import { render, staticRenderFns } from "./WechatSet.vue?vue&type=template&id=79c6cf47&scoped=true"
import script from "./WechatSet.vue?vue&type=script&lang=js"
export * from "./WechatSet.vue?vue&type=script&lang=js"
import style0 from "./WechatSet.vue?vue&type=style&index=0&id=79c6cf47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c6cf47",
  null
  
)

export default component.exports